import React from "react";
import { Button, Dialog, DialogContent, DialogActions } from "@mui/material";
import { GetApp as InstallIcon, Share as ShareIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { usePWA } from "../hooks/usePWA";

const PWAInstallPrompt = () => {
  const { t } = useTranslation();
  const { canInstall, installApp, isIOS, isStandalone, showManualInstallHelp } =
    usePWA();

  // If user is already in standalone mode (using the installed app), don't show any dialog
  if (isStandalone) {
    return null;
  }

  const handleInstall = async () => {
    await installApp();
  };

  const eventNotFiredAndIsNotIOs = !canInstall && !showManualInstallHelp;

  return null;
};

export default PWAInstallPrompt;
